import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue-apexcharts'
import router from './router/index'
import store from '@/state/store'
import vco from "v-click-outside"
import "@/design/index.scss";
import Sparkline from 'vue-sparklines';
// vue resource
import VueResource from 'vue-resource'
// element ui
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/da'
// vue form wizard
import VueFormWizard from 'vue-form-wizard'


Vue.use(VueFormWizard)
Vue.use(ElementUI, { locale })
Vue.use(VueResource)
require('dotenv').config()
Vue.http.options.root = process.env.VUE_APP_BITRIX_API + '/v1'
Vue.http.headers.common['X-Requested-With'] = 'XMLHttpRequest'

Vue.use(BootstrapVue);

Vue.config.productionTip = false

Vue.use(Vuelidate);
Vue.use(VueMask)
Vue.use(VueSweetalert2)
Vue.use(require('vue-chartist'))
Vue.use(vco)
Vue.use(Sparkline)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


// Global scroll to element id
Vue.prototype.$scrollTo = (elementId) => {
  Vue.nextTick(() => {
    var element = document.getElementById(elementId)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      })
    }
  })
}
